import React, { useEffect, useState } from "react";
import styled from "styled-components";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import upload from "../Assets/Img/upload.svg";

const Button = styled.button`
  /* Insert your favorite CSS code to style a button */
`;
const UploadFile = (props) => {
  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  function getBase64(file) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    });
  }

  const handleChange = async (event) => {
    if (props.typeFile.includes(event.target.files[0].type)) {
      console.log(event.target.files[0].type);

      const fileUploaded = event.target.files[0];
      setFile(fileUploaded);
      var base64File = await getBase64(fileUploaded);
      props.handleFile(base64File);
      props.setErrorMessage(false);
    } else {
      props.setErrorMessage(true);
    }
  };

  const [file, setFile] = useState();

  const [position] = useState(props.position ? props.position : "text-center");

  return (
    <>
      {!file && (
        <div
          style={{ cursor: "pointer" }}
          onClick={handleClick}
          className="d-flex flex-column align-items-center gap-2"
        >
          {/* Cerchio grigio con icona */}
          <div
            className="upload-dragdrop-image d-flex align-items-center justify-content-center bg-light rounded-circle"
            style={{ width: 100, height: 100 }}
          >
            <svg className="icon icon-primary icon-xl">
              <use href={`${iconSprite}#it-file`} />
            </svg>

            <div className="upload-dragdrop-loading">
              <div className="progress-donut" data-bs-progress-donut></div>
            </div>

            <div className="upload-dragdrop-success">
              <svg className="icon icon-primary icon-xs">
                <use href={`${iconSprite}#it-check`} />
              </svg>
            </div>
          </div>

          {/* Solo testo */}
          <div className="text-center">
            <h5 className="mb-0">{props.testoInterno ?? "Carica ISEE"}</h5>
          </div>

          {/* Input file nascosto */}
          <input
            type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: "none" }}
            accept={props.typeFile.join(",")}
          />
        </div>
      )}

      {file && (
        <>
          <div className="upload-dragdrop-loading">
            <div className="progress-donut" data-bs-progress-donut></div>
          </div>
          <div className="upload-dragdrop-success">
            <strong>File caricato correttamente</strong>
            <svg className="icon icon-primary icon-md">
              <use href={`${iconSprite}#it-check`} />
            </svg>
          </div>

          <div className="upload-dragdrop-text">
            <p className="upload-dragdrop-weight">
              <svg className="icon icon-primary icon-xs">
                <use href={`${iconSprite}#it-file`} />
              </svg>
            </p>

            <div className="row mb-3">
              <div className="col-12">
                <h6>
                  <svg
                    className="icon icon-danger "
                    onClick={() => {
                      setFile(), props.handleFile();
                    }}
                  >
                    <use xlinkHref={`${iconSprite}#it-close-circle`}></use>
                  </svg>
                  <a> {file.name}</a>
                </h6>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h6 className="text-success">
                  <svg className="icon icon-success">
                    <use xlinkHref={`${iconSprite}#it-check-circle`}></use>
                  </svg>
                  <a>
                    {" "}
                    {props.testoCaricamento
                      ? props.testoCaricamento
                      : "ISEE caricato correttamente!"}
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default UploadFile;
